/*
  Фильтр каталога сертификатов: пилюля-категория оставляет в списке только свои услуги.
  Услуга без категории видна всегда. Повторный клик по активной пилюле снимает фильтр.
  Без JS пилюли-фильтры скрыты классом no-js-hidden, список остаётся полным.

  Всё внутри guard'а: если секция стоит на странице дважды, тег скрипта тоже
  выполнится дважды, и объявленные снаружи const упали бы с ошибкой переобъявления.
*/

if (!customElements.get('certificates-filter')) {
  const CERTIFICATES_NO_FILTER = '';
  const CERTIFICATES_COUNT_PLACEHOLDER = '[count]';

  customElements.define(
    'certificates-filter',
    class CertificatesFilter extends HTMLElement {
      connectedCallback() {
        this.filters = Array.from(this.querySelectorAll('[data-certificates-filter]'));
        this.rows = Array.from(this.querySelectorAll('[data-certificates-category]'));
        this.status = this.querySelector('[data-certificates-status]');
        this.empty = this.querySelector('[data-certificates-empty]');

        if (this.filters.length === 0 || this.rows.length === 0) return;

        this.filters.forEach((filter) => filter.addEventListener('click', this.onFilterClick.bind(this)));

        const preselected = this.filters.find((filter) => filter.getAttribute('aria-pressed') === 'true');
        this.apply(preselected ? preselected.dataset.certificatesFilter : CERTIFICATES_NO_FILTER, false);
      }

      onFilterClick(event) {
        const filter = event.currentTarget;
        const isActive = filter.getAttribute('aria-pressed') === 'true';

        this.apply(isActive ? CERTIFICATES_NO_FILTER : filter.dataset.certificatesFilter, true);
      }

      /**
       * @param {string} category ключ категории; пустая строка снимает фильтр
       * @param {boolean} announce объявлять ли результат в aria-live области
       */
      apply(category, announce) {
        this.filters.forEach((filter) => {
          const isActive = category !== CERTIFICATES_NO_FILTER && filter.dataset.certificatesFilter === category;
          filter.setAttribute('aria-pressed', String(isActive));
        });

        let visibleCount = 0;

        this.rows.forEach((row) => {
          const rowCategory = row.dataset.certificatesCategory;
          const isVisible =
            category === CERTIFICATES_NO_FILTER ||
            rowCategory === CERTIFICATES_NO_FILTER ||
            rowCategory === category;

          row.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
        });

        if (this.empty) this.empty.hidden = visibleCount > 0;

        const statusTemplate = this.status && this.status.dataset.certificatesStatusTemplate;
        if (announce && statusTemplate) {
          this.status.textContent = statusTemplate.replace(CERTIFICATES_COUNT_PLACEHOLDER, String(visibleCount));
        }
      }
    }
  );
}
